import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { RequestStatus } from "../../models/requestStatus";
import RequestStatusBadge from "../RequestStatusBadge/RequestStatusBadge";
import { createTruncatedColumn } from "../../../../Common/utils/gridHelpers";

export const getProcessedRequestsColumns = (): GridColDef[] => {
  return [
    createTruncatedColumn("memberName", "Name", { flex: 0.8 }),
    createTruncatedColumn("memberEmail", "Email", { flex: 0.9 }),
    createTruncatedColumn("projectName", "Project", { flex: 0.9 }),
    createTruncatedColumn("role", "Role", { flex: 0.9 }),
    {
      field: "actions",
      headerName: "Status",
      width: 100,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: GridRenderCellParams<string>) => {
        const status = params.row.status as RequestStatus;
        const updatedBy = params.row.updatedBy;

        return <RequestStatusBadge status={status} updatedBy={updatedBy} />;
      },
    },
    {
      field: "updatedOn",
      headerName: "Date",
      flex: 0.9,
      disableColumnMenu: true,
    },
  ];
};
